"use client";

import { Suspense, useEffect, useRef, useState } from "react";

interface Props extends React.HTMLProps<HTMLDivElement> {
  className: string;
  leftClassName: string;
  centerClassName: string;
  rightClassName: string;
  children: React.ReactNode;
}
function Responsive({ className, leftClassName, rightClassName, centerClassName, children, ...props }: Props) {
  const elementRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<"l" | "c" | "r">("l");

  useEffect(() => {
    const handleScroll = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        if (rect.right < viewportWidth / 3) setPosition("l");
        else if (rect.right < (viewportWidth * 2) / 3) setPosition("c");
        else setPosition("r");
      }
    };
    const resizeObserver = new ResizeObserver(() => {
      handleScroll();
    });

    if (elementRef.current) {
      resizeObserver.observe(window.document.body);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      className={`${className} ${
        position === "l" ? rightClassName : position === "c" ? centerClassName : leftClassName
      }`}
      {...props}
      ref={elementRef}
    >
      {children}
    </div>
  );
}

export default function ResponsiveLR(props: Props) {
  return (
    <Suspense fallback={<div className={props.className}>{props.children}</div>}>
      <Responsive {...props} />
    </Suspense>
  );
}
